import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent {
  constructor(private router: Router) {
    
  }
  goToHome() {
    this.router.navigate(['/permissions'], {
      queryParamsHandling: 'merge',
    })
    // this.router.navigate(['/home'])
    // this.router.navigate(['/permissions'])

  }
}
